import { AlertCircle, AlertTriangle, Info, Lightbulb } from "lucide-react";
import { cn } from "@/lib/utils";

type CalloutType = "info" | "warning" | "danger" | "tip";

type CalloutProps = {
  type?: CalloutType;
  title?: string;
  children: React.ReactNode;
};

const icons = {
  info: Info,
  warning: AlertTriangle,
  danger: AlertCircle,
  tip: Lightbulb,
};

// Soft-surface pattern (DESIGN.md): tinted bg /10, border /40, status color only
// on border + icon — body and title text stay normal foreground for contrast.
const styles = {
  info: "bg-info/10 border-info/40",
  warning: "bg-warning/10 border-warning/40",
  danger: "bg-destructive/10 border-destructive/40",
  tip: "bg-success/10 border-success/40",
};

const iconStyles = {
  info: "text-info",
  warning: "text-warning",
  danger: "text-destructive",
  tip: "text-success",
};

export function Callout({ type = "info", title, children }: CalloutProps) {
  const Icon = icons[type];

  return (
    <div className={cn("border-l-4 px-3 py-2 my-2 rounded-r", styles[type])}>
      <div className="flex gap-2">
        <Icon className={cn("h-4 w-4 flex-shrink-0 mt-0.5", iconStyles[type])} />
        <div className="flex-1 text-xs">
          {title && <div className="font-semibold mb-0.5">{title}</div>}
          <div className="text-foreground/80">{children}</div>
        </div>
      </div>
    </div>
  );
}
